module.exports = "/_next/static/images/8a837a4638d14f4b461f03ddf84dbfe9-nu-card-lg@3x.jpg.webp";